import { type ProductData } from "~/domains/product/types/ProductData";
import { DownloadUrlLink, getDownloadProperty } from "~/common/components/Link";
import { trackRohsDownloadDatasheet } from "~/app/analytics/ga/ga";
import { useTranslation } from "react-i18next";
import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import { downloadBlobFromResponse } from "~/common/utils/ApiHelper";
import type { MouseEvent } from "react";

interface PdfDownloadLinkProps {
  product: Pick<ProductData, "code" | "designation">;
}

const buildRohsDownloadOccUrl = (productCode: string) => {
  let timezone;
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (e) {
    timezone = "UTC";
  }
  return occUrl(`/p/rohs/${productCode}`) + `?timezone=${timezone}`;
};

const PdfDownloadLink = ({ product }: PdfDownloadLinkProps) => {
  const { t } = useTranslation();

  const label = t("productDetailPage.downloadRohsPdf");

  const handleClick = async (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    trackRohsDownloadDatasheet(product.designation);
    const url = buildRohsDownloadOccUrl(product.code);
    const response = await occFetch(url);
    if (response.ok) {
      await downloadBlobFromResponse(response);
    }
  };

  return (
    <DownloadUrlLink
      download={getDownloadProperty(`${product.designation}.pdf`)}
      href={buildRohsDownloadOccUrl(product.code)}
      className={"scha__pdp__pdf-link"}
      onClick={handleClick}
    >
      {label}
    </DownloadUrlLink>
  );
};

export default PdfDownloadLink;
